class Place {
  constructor(place) {
    this.place = place;
  }

  get htmlClass() {
    return this.place.overdueInspectionsTotal
      ? 'overdue'
      : this.place.incomingInspectionsTotal
        ? 'incoming'
        : '';
  }

  get incomingInspectionsColor() {
    return this.incoming ? 'warning' : '';
  }

  get overdueInspectionsColor() {
    return this.overdue ? 'error' : '';
  }

  get hasInspections() {
    return this.place.inspectionsTotal > 0;
  }

  get overdue() {
    return this.place.overdueInspectionsTotal > 0;
  }

  get incoming() {
    return this.place.incomingInspectionsTotal > 0;
  }

  static create(place) {
    return new Place(place);
  }
}

const PlaceFactory = (place) => new Place(place);

export default PlaceFactory;
